const defaultError = 'Field {_field_} has an invalid value';
const vee = require('vee-validate/dist/locale/en').messages;

const custom_rules = {
  phone: defaultError,
  ip: 'The {_field_} field must be a valid IP address',
  pbx_internal_number: 'The {_field_} field already exists',
  latin_num: 'The {_field_} field can contain only the Latin alphabet and numbers',
  latin_num_ext:
    'The {_field_} field can contain only the Latin alphabet and numbers and special characters (.,-_).',
  login: 'The {_field_} field can contain only the Latin alphabet, numbers and underlines',
  accepted: 'The {_field_} field must be accepted',
  oneOf: 'The {_field_} field must be a valid value ({values})',
  mimes: 'The {_field_} field must be a valid file type ({values})',
  ext: 'The {_field_} field must be a valid file ({values})',
  password: `The password must contain digits and at least one uppercase and lowercase letter.`,
  sms_count: 'For encoding {encoding}, a character limit is set: {max_symbol_count}',
  url_ip: 'The field format is invalid',
  old_date: 'The date must be later than the current date',
  check_current_password: 'The current password is incorrect',
  need_scheme: 'Required to create a schema'
};

const laravel_rules = {
  active_url: 'The {_field_} field is not a valid URL',
  after: 'The {_field_} field must be a date after {date}',
  after_or_equal: 'The {_field_} field must be a date after or equal to {date}',
  array: 'The {_field_} field must be an array',
  before: 'The {_field_} field must be a date before {date}',
  before_or_equal: 'The {_field_} field must be a date before or equal to {date}',
  boolean: 'The {_field_} field must be true or false',
  confirmed: 'The {_field_} field confirmation does not match',
  date: 'The {_field_} field is not a valid date',
  date_equals: 'The {_field_} field must be a date equal to {date}',
  date_format: 'The {_field_} field does not match the format {format}',
  different: 'The {_field_} field must be different from field {other}',
  digits_between: 'The {_field_} field must be between {min} and {max} digits',
  dimensions: 'The {_field_} field has invalid image dimensions',
  distinct: 'The {_field_} field has a duplicate value',
  ends_with: 'The {_field_} field must end with one of the following: {values}',
  exists: 'The selected {_field_} is invalid',
  file: 'The {_field_} field must be a file',
  filled: 'The {_field_} field must have a value',
  image: 'The {_field_} field must be an image',
  in_array: 'The {_field_} field does not exist in {other}',
  ipv4: 'The {_field_} field must be a valid IPv4 address',
  ipv6: 'The {_field_} field must be a valid IPv6 address',
  json: 'The {_field_} field must be a valid JSON string',
  not_in: 'The selected {_field_} is invalid',
  not_regex: vee.regex,
  present: 'The {_field_} field must be present',
  required_if: 'The {_field_} field is required when {other} is {value}',
  required_recipient: 'The {_field_} field is required',
  required_unless: 'The {_field_} field is required unless {other} is in {values}',
  required_with: 'The {_field_} field is required when {values} is present',
  required_with_all: 'The {_field_} field is required when {values} are present',
  required_without: 'The {_field_} field is required when {values} is not present',
  required_without_all: 'The {_field_} field is required when none of {values} are present',
  same: 'The {_field_} field and {other} must match',
  starts_with: 'The {_field_} field must start with one of the following: {values}',
  string: 'The {_field_} field must be a string',
  timezone: 'The {_field_} field must be a valid zone',
  unique: 'The {_field_} field has already been taken',
  url: 'The {_field_} field format is invalid',
  uuid: 'The {_field_} field must be a valid UUID'
};

const size_laravel_rules = {
  between: {
    numeric: 'The {_field_} field must be between {min} and {max}',
    file: 'The {_field_} field must be between {min} and {max} kilobytes',
    string: 'The {_field_} field must be between {min} and {max} characters',
    array: 'The {_field_} field must have between {min} and {max} items'
  },
  gt: {
    numeric: 'The {_field_} field must be greater than {size}',
    file: 'The {_field_} field must be greater than {size} kilobytes',
    string: 'The {_field_} field must be greater than {size} characters',
    array: 'The {_field_} field must have more than {size} items'
  },
  gte: {
    numeric: 'The {_field_} field must be greater than or equal {size}',
    file: 'The {_field_} field must be greater than or equal {size} kilobytes',
    string: 'The {_field_} field must be greater than or equal {size} characters',
    array: 'The {_field_} field must have {size} items or more'
  },
  lt: {
    numeric: 'The {_field_} field must be less than {size}',
    file: 'The {_field_} field must be less than {size} kilobytes',
    string: 'The {_field_} field must be less than {size} characters',
    array: 'The {_field_} field must have less than {size} items'
  },
  lte: {
    numeric: 'The {_field_} field must be less than or equal {size}',
    file: 'The {_field_} field must be less than or equal {size} kilobytes',
    string: 'The {_field_} field must be less than or equal {size} characters',
    array: 'The {_field_} field must not have more than {size} items'
  },
  max: {
    numeric: 'The {_field_} field may not be greater than {size}',
    file: 'The {_field_} field may not be greater than {size} kilobytes',
    string: 'The {_field_} field may not be greater than {size} characters',
    array: 'The {_field_} field may not have more than {size} items'
  },
  min: {
    numeric: 'The {_field_} field must be at least {size}',
    file: 'The {_field_} field must be at least {size} kilobytes',
    string: 'The {_field_} field must be at least {size} characters',
    array: 'The {_field_} field must have at least {size} items'
  },
  size: {
    numeric: 'The {_field_} field must be {size}',
    file: 'The {_field_} field must be {size} kilobytes',
    string: 'The {_field_} field must be {size} characters',
    array: 'The {_field_} field must contain {size} items'
  }
};

const custom_laravel_rules = {
  sip_account_with_caller_id_limit: 'You can`t create more than {size} sip accounts with caller_id',
  action_link: 'You can`t create link',
  action_menu: 'You can`t create more than {size} menus',
  client_config_record_outgoing: 'Call recording is not available for this package',
  contact_limit: 'You can`t create more than {size} contacts',
  contact_method_limit: 'You can`t create more than {size} contact methods',
  entry_point_record_type: 'Call recording is not available for this package',
  sms_verification: 'Error SMS verification',
  check_balance: 'Not enough funds',
  change_package_limit: 'The PBX service package can be changed only once a day'
};

export const rules = Object.assign({}, vee, custom_rules, laravel_rules, custom_laravel_rules, {
  laravel: size_laravel_rules
});
